/*
 * pdp-zoom.js — self-contained click-to-zoom for the product gallery.
 * Dawn's lightbox (modal-opener) relies on the missing global.js, so this adds
 * its own overlay: click a gallery photo to open it large; click the large
 * photo to toggle full (100%) magnification, scroll to inspect; Esc / click
 * outside to close. No dependencies.
 */
(function () {
  var css =
    '.pdp-zoom-overlay{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.92);display:none;align-items:center;justify-content:center;overflow:auto;cursor:zoom-out;}' +
    '.pdp-zoom-overlay.is-open{display:flex;}' +
    '.pdp-zoom-img{max-width:95vw;max-height:92vh;object-fit:contain;cursor:zoom-in;transition:max-width .2s ease,max-height .2s ease;}' +
    '.pdp-zoom-img.is-mag{max-width:none;max-height:none;width:auto;height:auto;cursor:zoom-out;}' +
    '.pdp-zoom-close{position:fixed;top:1.4rem;right:1.8rem;width:3.2rem;height:3.2rem;background:none;border:0;color:#fff;font-size:2.8rem;line-height:1;cursor:pointer;z-index:1;}';
  var style = document.createElement('style');
  style.appendChild(document.createTextNode(css));

  var overlay, big;
  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pdp-zoom-overlay';
    var close = document.createElement('button');
    close.className = 'pdp-zoom-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '×';
    big = document.createElement('img');
    big.className = 'pdp-zoom-img';
    big.alt = '';
    overlay.appendChild(close);
    overlay.appendChild(big);
    overlay.addEventListener('click', function (e) {
      if (e.target === big) { big.classList.toggle('is-mag'); return; }
      closeZoom();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    document.body.appendChild(overlay);
  }
  function openZoom(src, alt) {
    if (!overlay) build();
    big.classList.remove('is-mag');
    big.src = src;
    big.alt = alt || '';
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function init() {
    document.head.appendChild(style);
    var imgs = document.querySelectorAll('.product__media-wrapper .product__media-item img');
    Array.prototype.forEach.call(imgs, function (img) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openZoom(img.currentSrc || img.src, img.alt);
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
